export const model = {
    id: '',
    name: '',
    created_at: '',
    updated_at: '',


};